import clone from "clone";
import { Layouts } from "../../constants/Constants";
import { Paths, Urls } from "../../constants/UrlConstants";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import { travelOrEapModules } from "../../constants/SMEModulesToMatchOn";

const 
  gpAppointmentsText = "GP appointments 24/7",
  healthSupportHeading = "Health Support"; 
  const muscleBoneJoint = "Muscle, bone, joint service";

export const _baseFooterLinks = [
  {
    Heading: "Quick Access",
    Links: [
      {
        Text: "Make a claim",
        Link: Paths.MakeAClaim
      },
      {
        Text: "My claims",
        Link: Paths.Claims
      },
      {
        Text: "Cover",
        Link: Paths.Cover
      }
    ]
  },
  {
    Heading: healthSupportHeading,
    Links: [
      {
        Text: "Health information",
        Link: Paths.HealthInformation
      },
      {
        Text: "24/7 health support line",
        Link: Paths.AskAMedicalExpert
      } 
    ]      
  },
  {
    Heading: "Useful Links",
    Links: [
      {
        Text: "Contact us",
        Link: Paths.ContactUs
      },
      {
        Text: "Inbox",
        Link: Paths.Inbox
      }
    ]
  }
];

export const getFooterLinks = (currentPolicy = {}, layout, isAgeAbove18) => {
  let processedFooterLinks = clone(_baseFooterLinks);

  if (!shouldShowIfAllSMEModulesDontMatch(currentPolicy, travelOrEapModules)) {
    processedFooterLinks[0].Links = [
      {
        Text: "Cover",
        Link: Paths.Cover
      }
    ];
  }
   
  if (layout === Layouts.HOL) {
    processedFooterLinks[1].Heading = "Health Hub";
    processedFooterLinks[1].Links[1].Text = "24/7 health support line";
    if (
      !(
        currentPolicy.IsLapsed
      ) && isAgeAbove18
    ) {
      processedFooterLinks[1].Links.push({
        Text: muscleBoneJoint, ////HOL 
        Link: Paths.WorkingBody
      });
    }
    if (
      !(
        currentPolicy.IsLapsed
      )
    ) {
      processedFooterLinks[1].Links.push({
        Text: gpAppointmentsText,
        Link: Paths.GPAppointments247
      });
    }
  } else if (currentPolicy) {
    if (currentPolicy.IsInternational) {
      processedFooterLinks[1].Links.splice(0, 1);
    }
  }

  if (
    layout === Layouts.MOL &&
    currentPolicy &&
    !(currentPolicy.IsInternational || currentPolicy.IsSaga)
  ) {
    processedFooterLinks[2].Links.push({
      Text: "Accessibility",
      Link: Urls.AccessibilityUrl
    });
  }
  //muscleBoneJoint for MOL
  if (
    layout === Layouts.MOL &&
    currentPolicy &&
    !(currentPolicy.IsLapsed) && isAgeAbove18
  ) {
    processedFooterLinks[1].Links.push({
      Text: muscleBoneJoint, //
      Link:Paths.WorkingBody
    });
  }
  if (
    layout === Layouts.MOL &&
    currentPolicy &&
    !(currentPolicy.IsLapsed)
  ) {
    processedFooterLinks[1].Links.push({
      Text: gpAppointmentsText,
      Link:Paths.GPAppointments247
    });
  }

  if (!window?.axa?.features?.healthUnlockedFeature) {
    processedFooterLinks[1].Links.splice(0, 1);
  }

  if (currentPolicy?.IsChildOnlyPolicy) {
    const healthSupport = processedFooterLinks.find(p => p.Heading === healthSupportHeading);

    if (healthSupport) {
      healthSupport.Links = healthSupport?.Links.filter(p => p.Text !== gpAppointmentsText);
    }
  } 
  
  return processedFooterLinks;
};
